import { VariableClaimMappingFormValue } from '../utils/getAuthenticatorInitialValues'

export const emptyVariableMapping: VariableClaimMappingFormValue = {
  destination: undefined,
  destinationKey: '',
  sourceKey: '',
}
